import React from 'react';
import { componentService } from 'js/services/component.service';
import { Route, Switch, useParams } from 'react-router-dom';

export const PageRoute = ({ children, path, ...args }) => {
    const { pathLang } = useParams();

    if (path) {
        return (
            <Route path={`/:pathLang(${pathLang})?/${path}`} {...args}>
                {children}
            </Route>
        );
    }

    return (
        <Route {...args}>
            {children}
        </Route>
    );
};

componentService.registerWebContentComponents({
    PageRouteSwitch: Switch,
    PageRoute
});
